import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppDispatch } from '../hooks';
import { login } from '../actions/Login';
export const Login = (_props) => {
    const dispatch = useAppDispatch();
    const username = React.useRef(null);
    const password = React.useRef(null);
    const submit = e => {
        e.preventDefault();
        if (username != null && password != null) {
            if (username.current != null && password.current != null) {
                dispatch(login(username.current.value, password.current.value));
            }
        }
    };
    return (_jsx("div", { style: { marginTop: '15px',
            paddingLeft: '15px',
            marginLeft: 'auto'
        }, children: _jsxs("form", { onSubmit: submit, children: [_jsxs("div", { children: [_jsx("div", { children: _jsx("label", { htmlFor: "username", children: "Anv\u00E4ndarnamn" }) }), _jsx("input", { id: "username", ref: username, type: "text", name: "username", autoFocus: true, autoCorrect: "off", autoCapitalize: "off", required: true, autoComplete: "username" })] }), _jsxs("div", { style: { marginTop: '15px' }, children: [_jsx("div", { children: _jsx("label", { htmlFor: "password", children: "L\u00F6senord" }) }), _jsx("input", { id: "password", ref: password, type: "password", name: "password", required: true, autoComplete: "current-password" })] }), _jsx("div", { style: { marginTop: '30px' }, children: _jsx("input", { type: "submit", value: "Logga in" }) })] }) }));
};
